export default "__VITE_ASSET__CEwiC7yO__"